import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toFixed' })
export class ToFixedPipe implements PipeTransform {

  transform(value: number | null | undefined, precision = 2, locale?: string): string {
    let fixed;
    if (typeof value !== 'number') {
      return '–';
    }
    try {
      const formatingOptions: Intl.NumberFormatOptions = {
        style: 'decimal',
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      };
      const formater = Intl.NumberFormat(locale, formatingOptions);
      fixed = formater.format(value);
      return fixed;
    } catch {
      fixed = value.toFixed(precision);
      fixed = fixed.replace('.', ',');
      return fixed;
    }
  }
}
